import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setDivisions } from 'Store/Organization/Divisions/DivisionsAction';
import { GET_DIVISIONS } from 'Store/Organization/Divisions/DivisionsType';
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getDivisions(): any {
    let payloadData : IPayload = {
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/divisions`,
        apiMethod : apiMethod.GET,
        payload : null
      }
    
    try {
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp,payloadData
        );
        yield put(setDivisions(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetDivisions() {
    yield takeEvery(GET_DIVISIONS, getDivisions)
}

export default function* combinedSaga() {
    yield all([
        watchGetDivisions()
    ])
}
